import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from '@mui/x-data-grid';
import { Card, CardBody } from "reactstrap";
import Button from '@mui/material/Button';
import DefaultImage from "../../assets/images/default-img.png";
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import { getAllApprovalList, updateApprovalStatus } from "../../api/casp/approval";
import { Action, PerPage } from "../../constants/Common";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import { ApprovalStatuses, DeliverableStatus } from "../../constants/Status";
import { Modules } from "../../constants/Module";
import NodataFound from "../../Components/Common/NoDataFound";
import MilestoneImage from "../../assets/images/icons/achieve.png";
import { TabModule } from "../../constants/Module";
import CommentModal from "../../Components/casp/common/CommentModal";
import { useParams } from "react-router-dom"
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import ApprovalIcon from '@mui/icons-material/Approval';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditDeliverableDrawer from "../../Components/ProjectSubmission/editDeliverable";
import { getDeliverableDetails } from "../../api/casp/deliverable";
import { withTranslation } from "react-i18next";

const DeliverableApprovalSubmission = (props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [columns, setColumn] = useState([]);
  const [triggerState, setTriggerState] = useState(+new Date());
  const [open, setOpen] = useState(false);
  const [rejectionComments, setRejectionComments] = useState();
  const [getApprovalId, setGetApprovalId] = useState(0);
  const [getParamsApiObj, setGetParamsApiObj] = useState();
  const [getStatus, setGetStatus] = useState();
  const [submit, setSubmit] = useState();
  const [mounted, setMounted] = useState(false);
  const { project } = useParams()
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: rowsPerPage,
  });
  const [selectedDeliverableRow, setSelectedDeliverableRow] = useState();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [action, setAction] = useState()

  const handleClickOpen = (approvalId, paramsApiObj, status) => {
    setOpen(true);
    setGetApprovalId(approvalId);
    setGetParamsApiObj(paramsApiObj);
    setGetStatus(status);
  };

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpen(false);
    setGetApprovalId(0);
    setGetParamsApiObj();
    setGetStatus();
    setRejectionComments();
  };
  const handleTriggerAdd = (_, comments) => {
    setSubmit(Action.SUBMIT);
    setRejectionComments(comments);
  };

  const handleApproval = async (approvalId, paramsApiObj, status) => {
    try {
      const updatedParamsApiObj = { ...paramsApiObj }; // Create a copy of paramsApiObj
      updatedParamsApiObj.status = status;
      const res = await updateApprovalStatus(
        parseInt(approvalId),
        updatedParamsApiObj
      );
      if (page === 0) {
        setTriggerState(+new Date());
      } else {
        setPage(0);
        setTriggerState(+new Date());
      }
      if (status === ApprovalStatuses.APPROVED) {
        toast.success(res.data.message);
      }
      if (status === ApprovalStatuses.REJECTED) {
        toast.info(res.data.message);
      }
    } catch (errors) {
      toast.error("Something went wrong.");
      setTriggerState(+new Date());
    }
  };

  const getDeliverableApprovalList = async ({ page = 1, perPage = 5 }) => {
    try {
      setIsLoading(true);
      const milestoneApprovalParams = {
        userId: loggedInUser.id,
        perPage: perPage,
        ...(isNaN(parseInt(project)) ? undefined : {
          projectId: parseInt(project)
        }),
        page,
        filterFields: ["module", "status", "currentApprovalUser", "moduleProposedStatus"],
        filterInputs: [
          Modules.DELIVERABLE,
          ApprovalStatuses.PENDING,
          ApprovalStatuses.PENDING,
          DeliverableStatus.DONE
        ],
      };

      const res = (await getAllApprovalList(milestoneApprovalParams)).data.data;
      if (res.data.length > 0) {
        let result = res.data.map((result) => ({
          deliverableName: result.moduleDetails.name,
          projectName: result.moduleDetails.project.name,
          pmName: result.creator.name,
          deliverableWeight: result.moduleDetails.weight,
          actions: Action.VIEW,
          id: result.id,
          actionObj: {
            moduleId: result.moduleId,
            module: result.module,
            projectId: result.moduleDetails.project.id,
          },
        }));
        setRows(result);
        setTotalRows(res.meta.total);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const paginationModelMethod = async (data) => {
    if (rowsPerPage !== data.pageSize) {
      setRowsPerPage(data.pageSize);
    } else {
      setRowsPerPage(data.pageSize);
      setPage(data.page);
    }
  };

  useEffect(() => {
    if (submit === Action.SUBMIT) {
      if (!rejectionComments) {
        toast.error("Comments is required.");
        setSubmit();
      } else {
        const updatedParamsApiObj = {
          ...getParamsApiObj,
          comments: rejectionComments,
        };
        handleApproval(getApprovalId, updatedParamsApiObj, getStatus);
        setSubmit();
        handleClose();
      }
    }
  }, [submit]);

  useEffect(() => {
    if (mounted) {
      getDeliverableApprovalList({ page: page + 1, perPage: rowsPerPage });
    }
    const data = () => {
      setColumn([
        {
          field: "deliverableName",
          headerName: props.t("Deliverable Name"),
          width: 300,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="MilestoneSubmissionIcon text-truncate"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="MuiDataGrid-cellContent mx-0" title={params.value}>
                {params.row.deliverableName}
              </div>
            </div>
          ),
        },
        {
          field: "projectName",
          headerName: props.t("Startup Name"),
          width: 300,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="ProjSubmissionIcon text-truncate"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="MuiDataGrid-cellContent mx-0" title={params.value}>
                {params.row.projectName}
              </div>
            </div>
          ),
        },
        {
          field: "pmName",
          headerName: "PM " + props.t("Name"),
          width: 300,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="MilestoneSubmissionIcon"
              style={{ display: "flex", alignItems: "center" }}
            >
              {params.row.pmName && (
                <img
                  src={DefaultImage}
                  alt={params.row.pmName}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                />
              )}
              <div className="MuiDataGrid-cellContent mx-2">
                {params.row.pmName}
              </div>
            </div>
          ),
        },
        {
          field: "deliverableWeight",
          headerName: props.t("Weight"),
          width: 200,
          headerClassName: "super-app-theme--header",
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <div
              className="MilestoneSubmissionIcon"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="MuiDataGrid-cellContent mx-2">
                {params.row.deliverableWeight}
              </div>
            </div>
          ),
        },

        {
          field: "actions",
          headerName: props.t("Actions"),
          width: 350,
          headerClassName: "super-app-theme--header",
          sortable: false,
          filterable: false,
          hideable: false,
          renderCell: (params) => (
            <div
              className="proSubmissionActions"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Button
                disableElevation
                variant="contained"
                className="approveBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#90EE90",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleApproval(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.APPROVED
                  )
                }
              >
                <DoneIcon />
                {props.t('Approve')}
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="error"
                className="rejectBtn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#FFC0CB",
                  color: "black",
                  textTransform: "none",
                }}
                onClick={() =>
                  handleClickOpen(
                    params.row.id,
                    params.row.actionObj,
                    ApprovalStatuses.REJECTED
                  )
                }
              >
                <ClearIcon />
               {props.t('Reject')}
              </Button>
              <RemoveRedEyeOutlinedIcon
                style={{ cursor: "pointer", fill: '#296CED' }}
                onClick={() => handleClick(params.row, Action.VIEW)}
              />
            </div>
          ),
        },
      ]);
    };
    data();
  }, [page, triggerState, localStorage.getItem("I18N_LANGUAGE")]);

  const handleClick = async (params, action) => {
    const res = await getDeliverableDetails(params.actionObj.moduleId, { projectId: params.actionObj.projectId });
    setIsDrawerOpen(true);
    setSelectedDeliverableRow(res.data.data);
    setAction(action)
  };

  const handleCloseDrawer = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setIsDrawerOpen(false);
    setSelectedDeliverableRow();
    setAction()
  };

  useEffect(() => {
    setRows([]);
    setPaginationModel({
      page: 1,
      pageSize: rowsPerPage,
    });
    if (page === 0) {
      setTriggerState(+new Date());
    } else {
      setPage(0);
    }
    setMounted(true);

  }, [rowsPerPage]);

  const getRowId = (row) => row.id;

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
              })

              if (!newFaviconElems.length) {
                return
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              )

              if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              )
              const iconToShow = props.module === TabModule.PROJECT_APPROVAL ? <ApprovalIcon /> : <DoneAllIcon />

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(iconToShow)}</svg>`
                )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
              }
            } catch (e) {
              console.error(e)
            }
          }}
        >
          <title>{props.t('Deliverable Submission List')}</title>
        </Helmet>
        <Container fluid>
          {/* BreadCrumb area starts */}
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t(props.module)} />
          </div>
          <div className="milestoneSubmission accordionTable my-4">
            <CommentModal
              handleRejectModal={handleClose}
              open={open}
              handleApproval={handleTriggerAdd}
              module={Modules.DELIVERABLE}
            />
            <Card>
              <CardBody>
                <div style={{ height: 400, width: "100%" }}>
                  <Box
                    sx={{
                      height: 400,
                      width: "100%",
                      "& .super-app-theme--header": {
                        backgroundColor: "rgba(0, 173, 255, 0.55)",
                      },
                    }}
                  >
                    {rows.length > 0 && (
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                          pagination: {
                            paginationModel: { pageSize: rowsPerPage },
                          },
                        }}
                        pageSizeOptions={PerPage}
                        style={{ border: "unset" }}
                        paginationMode="server"
                        rowCount={totalRows}
                        key={triggerState}
                        onPaginationModelChange={paginationModelMethod}
                        loading={isLoading}
                        disableRowSelectionOnClick
                        getRowId={getRowId}
                      />
                    )}
                    {rows.length === 0 && isLoading && <Loader />}
                    {rows.length === 0 && !isLoading && (
                      <NodataFound
                        text={props.t(`No ${props.module} to show`)}
                        icon={MilestoneImage}
                      />
                    )}
                  </Box>
                </div>
              </CardBody>
            </Card>
          </div>
        </Container>

        {isDrawerOpen && (
          <React.Fragment>
            <EditDeliverableDrawer
              isOpen={isDrawerOpen}
              handleClose={handleCloseDrawer}
              selectedRow={selectedDeliverableRow}
              action={action}
              projectDetails={
                {
                  status: selectedDeliverableRow.project?.status,
                  projectCost: selectedDeliverableRow.project?.projectCost,
                  startDate: selectedDeliverableRow.project?.startDate,
                  endDate: selectedDeliverableRow.project?.endDate
                }
              }
            />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

export default withTranslation() (DeliverableApprovalSubmission)
